import { render, staticRenderFns } from "./ExpiracaoReservasModal.vue?vue&type=template&id=195714e6&scoped=true&"
import script from "./ExpiracaoReservasModal.vue?vue&type=script&lang=js&"
export * from "./ExpiracaoReservasModal.vue?vue&type=script&lang=js&"
import style0 from "./ExpiracaoReservasModal.vue?vue&type=style&index=0&id=195714e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195714e6",
  null
  
)

export default component.exports